import React from "react";
import { Routes, Route } from "react-router-dom";
import GlobalRoutes from "./GlobalRoutes";
const RoutesIndex = () => {
    console.log('RoutesIndex Entry')
    return (
        <Routes>
            <Route path="/" element={<GlobalRoutes />} />
            <Route path="/:lng/*" element={<GlobalRoutes />} />
        </Routes>
    );
};
export default RoutesIndex;
